module.exports = zingchart;